//
// locales/vanilla/id.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/id.json';
import localeData from 'react-intl/locale-data/id.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
